export default "__VITE_ASSET__CSZi0z6X__"